<template>
	<div class="comp-record-sd-detail">
		<div class="comp-record-sdd-title"><span @click="goBack"></span></div>
		<div class="comp-record-sdd-box" id="comp-record-sdd-items">
			<div class="comp-record-sdd-items">
				<div class="comp-record-sdd-item" v-for="msg in msgList" :class="{'comp-record-sdd-item-active': msg.id == recordId}">
					<div class="comp-record-sdd-avatar">
						<img :src="msg.fans_photo" alt="" v-if="msg.is_me === 0">
						<img :src="msg.custom_photo | connectHost" alt="" v-else>
					</div>
					<div class="comp-record-sdd-info">
						<div class="comp-record-sddi-title">
							<span v-if="msg.is_me === 0">{{msg.fans_name}}</span>
							<span v-else>{{msg.cusotm_name}}</span>
							<span>{{msg.send_time}}</span>
						</div>
						<div class="comp-record-sddi-msg" v-html="$options.filters.formatMsg(msg.content,msg.type)"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {getRecordListByFansAndIdSort} from '../../network/local/search.js'

	export default {
		name: "ChatRecodSearchDetailComp",
		props: {
			keyword: {
				type: String,
				default: ''
			},
			fans: {
				type: Object,
				default: function() {
					return {}
				}
			},
			recordId:{
				type: Number,
				default: 0
			}
		},
		data() {
			return {
				msgList: []
			}
		},
		methods: {
			// 根据粉丝id，聊天记录内容，获取对应的聊天记录信息
			getRecord() {
				this.msgList = []
				if(this.recordId > 0){
					getRecordListByFansAndIdSort(this.fans.id, this.recordId, 'asc', data => {
						this.msgList = data
						this.$nextTick(()=>{
							getRecordListByFansAndIdSort(this.fans.id, this.recordId, 'desc', data2 => {
								let page = document.getElementById("comp-record-sdd-items")
								let o_scroll_h = 0
								if(page !== undefined){
									  o_scroll_h = page.scrollHeight
								} 
								for (let i = 0; i < data2.length; i++) {
									this.msgList.unshift(data2[i])
								}
								this.$nextTick(()=>{
									let top = page.scrollHeight - o_scroll_h
									page.scrollTop = top
								})
							})
						})
						
					})
				}
			},
			
			// 返回
			goBack(){
				this.$emit('go-back')
			}
		},
		watch: {
			recordId(nVal){
				this.getRecord()
			}
		}
	}
</script>

<style>
	.comp-record-sd-detail {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 221px;
		overflow: hidden;
		color: #999999;
	}

	.comp-record-sd-detail .comp-record-sdd-title {
		height: 30px;
		line-height: 30px;
		padding: 5px 20px;
		display: flex;
		justify-content: space-between;
		border-bottom: 1px solid #e4e4e4;
	}
	
	.comp-record-sdd-title span{
		height: 30px;
		width: 30px;
		display: inline-block;
		background-image: url(../../assets/img/back-70-32.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 22px auto;
		cursor: pointer;
	}

	.comp-record-sdd-box {
		position: absolute;
		top: 41px;
		right: 0;
		bottom: 0;
		left: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.comp-record-sdd-box .comp-record-sdd-items {
		height: auto;
		font-size: 12px;
	}

	.comp-record-sdd-items .comp-record-sdd-item {
		padding: 10px 20px;
		overflow: hidden;
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
		border-bottom: 1px solid #e6e6e6;
	}
	
	.comp-record-sdd-item-active{
		background-color: #e6e6e6;
	}

	.comp-record-sdd-item .comp-record-sdd-avatar {
		width: 36px;
		height: 36px;
		margin-right: 10px;
	}

	.comp-record-sdd-avatar img {
		width: 100%;
		height: 100%;
		border-radius: 4px;
	}

	.comp-record-sdd-item .comp-record-sdd-info {
		flex-grow: 1;
		width: 0;
		height: auto;
		overflow: hidden;
	}

	.comp-record-sdd-info .comp-record-sddi-title {
		height: 18px;
		line-height: 18px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.comp-record-sdd-info .comp-record-sddi-msg {
		margin-top: 5px;
		word-break: break-word;
		color: #333333;
		line-height: 20px;
	}
	.comp-record-sddi-msg > .chat-program{
		border: 1px solid #e2e2e2;
		border-radius: 4px;
	}
	.comp-record-sddi-msg > .chat-file{
		border: 1px solid #e2e2e2;
		border-radius: 4px;
	}
</style>
